module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All users")]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "admin-gm-breadcrumbs background-2-16-after",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "companies background-1-100-after color-2-77",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-100-after color-2-77 active",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar border-1-20 background-1-20 color-2-100"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.usersSum) + " users")])]), _vm._v(" "), _c('router-link', {
    staticClass: "data-list-add data-list-add-custom border-1-40 color-2-100",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'add-user' : 'ca-add-user'
      }
    }
  }, [_c('span', {
    staticClass: "data-list-add-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 15 15"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 15 15",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "points": "8.8,6.2 15,6.2 15,8.8 8.8,8.8 8.8,15 6.2,15 6.2,8.8 0,8.8 0,6.2 6.2,6.2 6.2,0 8.8,0"
    }
  })])]), _vm._v("\n        Add new user\n      ")])], 1), _vm._v(" "), (this.users.length && _vm.getUserRole === 'gm') ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        return _vm.csvExport(_vm.csvData)
      }
    }
  }, [_vm._v("Export all users")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "fixed",
      "left": "-2000px",
      "bottom": "-2000px"
    },
    attrs: {
      "href": "#",
      "id": "csvDownload"
    }
  }, [_vm._v("download users")]), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters border-1-40"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied data-list-selected-filters-applied-custom background-1-40 color-2-100"
  }, [_c('span', {
    staticClass: "data-list-selected-filters-applied-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 482.41 -477.986 963.167 971.987"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "482.41 -477.986 963.167 971.987",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M848.216-18.686c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3\n                c16.5-19.8,25.6-29.601,25.6-49.2v-272.8c0-15,5.7-29.5,15.8-40.601l353.799-383.899c26.5-28.8,6.101-75.5-33.1-75.5h-873\n                c-39.2,0-59.7,46.6-33.1,75.5L848.216-18.686z"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.editedUsers.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      staticClass: "data-list-selected-filters-body-button-custom background-1-20 color-2-100",
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('span', {
      staticClass: "data-list-selected-filters-body-button-icon color-1-100"
    }, [_c('svg', {
      staticClass: "color-1-100",
      staticStyle: {
        "enable-background": "new 0 0 15.002 15.002"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15.002 15.002",
        "xml:space": "preserve"
      }
    }, [_c('polygon', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_2_",
        "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n                12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
      }
    })])])])
  }), _vm._v(" "), _c('a', {
    staticClass: "data-list-selected-filters-remove-all color-2-100",
    attrs: {
      "href": "#",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeAllFilters($event)
      },
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data border-1-20"
  }, [_c('thead', {
    staticClass: "table-head-mobile-custom background-1-40-before border-1-40",
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [_c('span', {
    staticClass: "table-head-mobile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 482.41 -477.986 963.167 971.987"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "482.41 -477.986 963.167 971.987",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M848.216-18.686c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3\n                c16.5-19.8,25.6-29.601,25.6-49.2v-272.8c0-15,5.7-29.5,15.8-40.601l353.799-383.899c26.5-28.8,6.101-75.5-33.1-75.5h-873\n                c-39.2,0-59.7,46.6-33.1,75.5L848.216-18.686z"
    }
  })])])]), _vm._v(" "), ((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9",
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      staticClass: "data-list-selected-filters-body-button-custom background-1-20 color-2-100",
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('span', {
      staticClass: "data-list-selected-filters-body-button-icon color-1-100"
    }, [_c('svg', {
      staticClass: "color-1-100",
      staticStyle: {
        "enable-background": "new 0 0 15.002 15.002"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15.002 15.002",
        "xml:space": "preserve"
      }
    }, [_c('polygon', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_2_",
        "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n                      12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
      }
    })])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil background-1-10 border-1-20",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistSearchInOptions('name')
    },
    attrs: {
      "colspan": "2",
      "scope": "col"
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('name')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "Full name",
      "aria-label": "Full name",
      "type": "search",
      "placeholder": "Full name"
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "column-email-head table-head-ceil background-1-10 border-1-20",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistSearchInOptions('email')
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('email')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchEmail),
      expression: "searchEmail"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "Email",
      "aria-label": "Email",
      "type": "search",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.searchEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "column-role-head table-head-hover table-head-ceil background-1-10 border-1-20",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getRolesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getRolesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getRolesForSelect
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-company-head table-head-hover table-head-ceil background-1-10 border-1-20",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getTitlesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getTitlesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getTitlesForSelect
    },
    model: {
      value: (_vm.job_title),
      callback: function($$v) {
        _vm.job_title = $$v
      },
      expression: "job_title"
    }
  })], 1)]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('th', {
    staticClass: "column-company-head table-head-hover table-head-ceil background-1-10 border-1-20",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(5)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 5
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 5),
      expression: "filerTableHead.selectedCeil === 5"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getCompaniesForSelect
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('created', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'created' && this.userOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'created' && !this.userOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('login', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'login' && this.userOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'login' && !this.userOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil background-1-10 border-1-20",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(7)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 7
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 7),
      expression: "filerTableHead.selectedCeil === 7"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-7",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "multiple": true,
      "options": _vm.getStatusesForSelect
    },
    model: {
      value: (_vm.userStatus),
      callback: function($$v) {
        _vm.userStatus = $$v
      },
      expression: "userStatus"
    }
  })], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedUsers), function(user, i) {
    return (i < _vm.offset) ? _c('tr', {
      attrs: {
        "tabindex": "0"
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.goToUserEdit(user.id)
        },
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToUserEdit(user.id)
        }
      }
    }, [(user.type === 'show') ? _c('td', {
      staticClass: "id-cell text-center cellpadding border-1-20",
      attrs: {
        "data-title": "ID"
      }
    }, [_vm._v(_vm._s(user.id))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "name-cell cellpadding border-1-20",
      attrs: {
        "data-title": "ID and full name:"
      }
    }, [(_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) ? _c('span', [_vm._v(_vm._s(user.id) + " ")]) : _vm._e(), _vm._v("\n            " + _vm._s(user.first_name || user.last_name ? (user.first_name ? user.first_name + ' ' : '') + (user.last_name ? user.last_name : '') : 'n/a') + "\n          ")]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "email-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Email:"
      }
    }, [_vm._v(_vm._s(user.email ? user.email : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "role-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Role:"
      }
    }, [_vm._v(_vm._s(user.role ? user.role.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "title-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Title:"
      }
    }, [_vm._v(_vm._s(user.job_title ? user.job_title : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show' && _vm.getUserRole === 'gm') ? _c('td', {
      staticClass: "company-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Company:"
      }
    }, [_vm._v(_vm._s(user.company ? user.company.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "created-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Created on:"
      }
    }, [_vm._v(_vm._s(user.created ? _vm.lastActiveTime(user.created) : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "last-login-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Last login:"
      }
    }, [_vm._v(_vm._s(user.last_login ? _vm.lastActiveTime(user.last_login) : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "status-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Status:"
      }
    }, [_vm._v(_vm._s(_vm.getUserStatus(user).label))]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), (this.offset <= this.editedUsers.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn background-1-100",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(6), _vm._v("Load more\n        ")])]) : _vm._e()])]), _vm._v(" "), (false) ? _c('app-spiner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Created "), _c('br'), _vm._v("on")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Last login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0823ab4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/UsersList.vue
// module id = 987
// module chunks = 1